import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { CustomEase } from "gsap/CustomEase";
import { Draggable } from "gsap/Draggable";
import * as Tone from 'tone';
import flowerSvg from 'bundle-text:../../svg/flower__slider.svg';

// Register GSAP plugins
gsap.registerPlugin(Draggable, MorphSVGPlugin, CustomEase);

// Add this flag at the top of your file, with other variables
let isTransitioning = false;

document.addEventListener('DOMContentLoaded', function () {
    // Check if we're coming from a redirect
    if (sessionStorage.getItem('redirecting')) {
        sessionStorage.removeItem('redirecting');
        return;
    };
    // Inject SVGs
    const injectSvg = (selector, svgContent) => {
        document.querySelectorAll(selector).forEach(span => {
            span.innerHTML = svgContent;
        });
    };
    injectSvg('.flower__cntrl span', flowerSvg);

    gsap.set(".flower__up", {
        backgroundColor: "#eeeeee",
        scaleX: 0,
        scaleY: 0,
        opacity: 0.1,
    });
    // gsap.set(".TrackGroup line", {
    //     strokeDasharray: "100%",
    //     strokeDashoffset: "100%"
    // });
    gsap.set(".HandleGroup path", {
        autoAlpha: 0,
    });
    gsap.set(".flower__down", {
        autoAlpha: 0,
    });
    gsap.to(".flower__down", {
        autoAlpha: 1,
        duration: 0.5,
        ease: "power2.inOut",
        delay: 0.5,
    });
    // Add audio setup
    const soundURL = require("url:../../audio/P_HIGH_01.m4a");

    // Create shared effects chain
    const reverb = new Tone.Reverb({
        decay: 3,
        wet: 0.75,
    }).toDestination();

    // Add delay for loop masking
    const loopMaskDelay = new Tone.FeedbackDelay({
        delayTime: 0.5,    // Longer delay time to mask the loop
        feedback: 0.125,     // Moderate feedback for natural decay
        wet: 0.25          // Blend with dry signal
    }).connect(reverb);

    // Separate gain nodes for WAV and noise
    const wavGainNode = new Tone.Gain(1).connect(reverb).toDestination();
    const noiseGainNode = new Tone.Gain(2).toDestination();
    const secondPlayerGainNode = new Tone.Gain(3).connect(loopMaskDelay);

    // Set initial BPM
    const baseBPM = 26; // You can adjust this base tempo
    Tone.Transport.bpm.value = baseBPM;

    // Create audio player with its own volume control
    const player = new Tone.Player({
        url: soundURL,
        loop: false,
        volume: -5,
        fadeIn: 0.5,  
        fadeOut: 0.1,  
    }).connect(wavGainNode);

    // Create a loop that plays on quarter notes
    const loop = new Tone.Loop((time) => {
        player.start(time).stop(time + 0.75); // Increased from 0.25 to 0.75 seconds

        const oneBar = (60 / Tone.Transport.bpm.value) * 1;

        // Create a timeline for the animation
        const tl = gsap.timeline();
        tl.to(".flower__shell abbr", {
            transformOrigin: "center center",
            scaleX: 2,
            scaleY: 2,
            duration: 0.0675
        })
            .to(".flower__shell abbr", {
                transformOrigin: "center center",
                scaleX: 1,
                scaleY: 1,
                duration: 0.5,
                ease: "elastic.out(1, 0.3)"
            })
            ;

    }, "4n").start(0); // "4n" means quarter notes

    gsap.to(".flower__shell abbr", {
        autoAlpha: 0,
    });
    // Modify toggle function to control Transport
    function toggleAudio(buttonId, player, targetSection) {
        const button = document.getElementById(buttonId);
        const section = document.getElementById(targetSection);

        button.onclick = async function () {
            if (isTransitioning) return;
            isTransitioning = true;

            // Disable pointer events during transition
            document.querySelector('.flower__cntrl').style.pointerEvents = 'none';

            const isChecked = button.getAttribute("aria-checked") === "true";
            button.setAttribute("aria-checked", !isChecked ? "true" : "false");

            if (!isChecked) {
                // Calculate one bar duration for all animations
                const oneBar = (60 / Tone.Transport.bpm.value) * 1;

                // Start Transport
                Tone.Transport.start();

                // Start noise if not already playing
                if (!isGongPlaying) {
                    gongSynthTwo.start();
                }

                // Initial state setup
                noiseGainNode.gain.value = 0;
                wavGainNode.gain.setValueAtTime(0, Tone.now());

                // Create main timeline for coordinated animations
                const mainTl = gsap.timeline({
                    onComplete: () => {
                        isTransitioning = false;
                        document.querySelector('.flower__cntrl').style.pointerEvents = 'auto';
                        gsap.to(button, { opacity: 1, duration: 0.1 });
                    }
                });

                mainTl
                    // Initial button feedback
                    .to(button, {
                        opacity: 0.25,
                        duration: 0.2,
                        boxShadow: "0px 0 1em 0 color-mix(in srgb, lime 30%, transparent 100%)",

                    })

                    // Start audio fades
                    .add(() => {
                        noiseGainNode.gain.rampTo(2, 1);
                        wavGainNode.gain.linearRampToValueAtTime(1, Tone.now() + oneBar);
                        secondPlayerGainNode.gain.rampTo(4, 1);
                        secondPlayer.start();
                    })

                    // Start the loop
                    .add(() => { loop.start(0) })

                    // Delayed animations after one bar
                    .to(".flower__up", {
                        backgroundColor: "wheat",
                        scaleX: 0.975,
                        scaleY: 0.6,
                        opacity: 1,
                        duration: 0.0675,
                        ease: CustomEase.create("custom", "M0,0 C-0.011,-0.041 -0.008,0.552 0.266,0.828 0.527,1.089 0.642,1 1,1"),
                        delay: oneBar
                    })

                    .to(".flower__shell abbr", {
                        autoAlpha: 1,
                        duration: 0.5,
                    }, `-=0.0675`)

                    .to(".HandleGroup path", {
                        autoAlpha: 1,
                        duration: 0.25
                    }, `-=${oneBar - 1.875}`)

                    .to(".redShape", {
                        fill: "hsla(0, 100%, 50%, 1)",
                        duration: 1
                    }, `-=${oneBar - 0.25}`)

                    .to(`#${targetSection}`, {
                        opacity: 1
                    });

                isGongPlaying = true;

            } else {
                // Stop playback immediately
                Tone.Transport.stop();
                loop.stop();
                secondPlayer.stop();

                // Create timeline for stopping animations
                const stopTl = gsap.timeline({
                    onComplete: () => {
                        isTransitioning = false;
                        document.querySelector('.flower__cntrl').style.pointerEvents = 'none';
                        gsap.to(button, { opacity: 1, duration: 0.1, boxShadow: "0px 0 1em 0.25em color-mix(in srgb, #efefef 100%, transparent 70%)", });
                    }
                });

                stopTl
                    .to(button, { opacity: 0.5, duration: 0.1, boxShadow: "0px 0 1em 0.25em color-mix(in srgb, #ffffff 100%, transparent 70%)", })

                    // Fade out audio
                    .add(() => {
                        noiseGainNode.gain.rampTo(0, 0.5);
                        wavGainNode.gain.rampTo(0, 0.5);
                        secondPlayerGainNode.gain.rampTo(3, 1);
                    })

                    // Reset visual elements
                    .to(".flower__up", {
                        backgroundColor: "#eeeeee",
                        scaleX: 0,
                        scaleY: 0,
                        opacity: 0,
                        duration: 0.2
                    }, 0)

                    .to([".flower__shell abbr", ".HandleGroup path"], {
                        autoAlpha: 0,
                        duration: 0.125
                    }, 0)

                    .to(".redShape", {
                        fill: "hsla(0, 0%, 93%, 1)",
                        duration: 0.5,
                    });

                isGongPlaying = false;
            }
        };
    }

    // Initialize toggle
    toggleAudio("theSmallSwitch1", player, "flower");

    // Add these audio components after your existing Tone.js setup

    // Initialize noise components with separate volume control
    const gongSynthTwo = new Tone.Noise("brown").connect(noiseGainNode);
    gongSynthTwo.volume.value = -35; // Initial noise volume in dB

    const noiseEnvelope = new Tone.AmplitudeEnvelope({
        attack: 0.5,
        decay: 0.9,
        sustain: 0.5,
        release: 1
    }).connect(noiseGainNode);

    // Connect noise to envelope
    gongSynthTwo.connect(noiseEnvelope);

    let isGongPlaying = false;

    // Initialize slider functionality after SVG injection
    document.querySelectorAll('.flower__cntrl').forEach(control => {
        const handle = control.querySelector('.HandleGroup');
        const track = control.querySelector('.TrackGroup');
        const pathOne = control.querySelector('.flowerPathZero');
        const pathTwo = control.querySelector('.flowerPathOne');
        const svg = control.querySelector('svg'); // Get the SVG element

        // Get track bounds
        const trackBounds = track.getBBox();
        const minY = trackBounds.y;
        const maxY = trackBounds.y + trackBounds.height;
        const startY = minY + (trackBounds.height * 0.5);

        // Define the update function first
        function updateFlowerAndAudio(progress, shouldAnimateMorph = false) {
            // Keep existing morph animation
            if (shouldAnimateMorph) {
                gsap.to(morphTween, {
                    progress: progress,
                    duration: 0.3,
                    ease: "elastic.out(1, 0.3)",
                });
            } else {
                morphTween.progress(progress);
            }

            // Rest of the update function remains the same
            const scale = progress >= 0.5
                ? 1
                : 0.4 + (progress * 1.2);

            const yPosition = progress >= 0.5
                ? 0
                : (0.5 - progress) * 8;

            // Add color interpolation while keeping existing animations
            const backgroundColor = progress >= 0.5
                ? "wheat"
                : gsap.utils.interpolate("white", "wheat", progress * 2);

            gsap.to(".flower__up", {
                scaleX: scale,
                y: yPosition + 'em',
                backgroundColor: backgroundColor,
                duration: 0.4,
                ease: "elastic.out(1, 0.3)",
            });
            gsap.to(".flower__shell", {
                y: yPosition + 'em',
                duration: 0.4,
                ease: "elastic.out(1, 0.3)",
            });

            // Keep all audio updates
            if (progress >= 0.5) {
                const upperProgress = (progress - 0.5) * 2;
                Tone.Transport.bpm.value = baseBPM + (upperProgress * baseBPM * 0.5);
            } else {
                const lowerProgress = progress * 2;
                Tone.Transport.bpm.value = (baseBPM * 0.5) + (lowerProgress * baseBPM * 0.5);
            }

            // Trigger noise bursts
            noiseEnvelope.triggerAttackRelease(0.05);

            // Update reverb
            if (progress >= 0.5) {
                const upperProgress = (progress - 0.5) * 2;
                reverb.decay = 1.5 + (upperProgress * 1.5);
            } else {
                const lowerProgress = progress * 2;
                reverb.decay = lowerProgress * 1.5;
            }
        }

        // Add click handler for the track
        track.addEventListener('click', function (e) {
            // Get click position relative to SVG
            const svgRect = svg.getBoundingClientRect();
            const clickY = e.clientY - svgRect.top;

            // Convert to local coordinates using SVG's viewBox
            const viewBox = svg.viewBox.baseVal;
            const localY = (clickY * viewBox.height) / svgRect.height;
            const progress = 1 - ((localY - minY) / (maxY - minY));

            // Calculate new handle position
            const newY = localY - startY;

            // Ensure the position is within bounds
            const boundedY = Math.max(
                (minY + (trackBounds.height * 0.2)) - startY,
                Math.min(
                    (maxY - (trackBounds.height * 0.1)) - startY,
                    newY
                )
            );

            // Animate handle to new position
            gsap.to(handle, {
                y: boundedY,
                duration: 0.3,
                ease: "power2.out",
                onUpdate: function () {
                    // Pass true to animate the morph
                    updateFlowerAndAudio(progress, true);
                }
            });
        });

        // Set initial position and state
        gsap.set(handle, {
            y: 0,
            transformOrigin: "center center"
        });

        // Create the morph tween once and pause it
        const morphTween = gsap.to(pathOne, {
            morphSVG: {
                shape: pathTwo,
                shapeIndex: "auto"
            },
            paused: true,
            duration: 1,
        });

        // Set initial morph progress to 0.5 (50%)
        morphTween.progress(0.5);

        // Create draggable instance
        Draggable.create(handle, {
            type: "y",
            bounds: {
                minY: (minY + (trackBounds.height * 0.2)) - startY,
                maxY: (maxY - (trackBounds.height * 0.1)) - startY
            },
            inertia: true,
            onDragStart: function () {
                // Start noise on drag start
                if (!isGongPlaying) {
                    gongSynthTwo.start();
                    isGongPlaying = true;
                }

                // Existing morphing setup...
                gsap.to(handle, {
                    scale: 0.95,
                    duration: 0.125
                });
            },
            onDrag: function () {
                const progress = 1 - ((this.y - (minY - startY)) / (maxY - minY));
                updateFlowerAndAudio(progress, false);
            },
            onDragEnd: function () {
                // Stop noise
                noiseEnvelope.triggerRelease();
                setTimeout(() => {
                    gsap.to(handle, {
                        scale: 1.05,
                        duration: 0.125
                    });
                }, 100);
            }
        });

        // Add ARIA attributes and role to the control
        control.setAttribute('role', 'slider');
        control.setAttribute('aria-label', 'Flower sound control');
        control.setAttribute('aria-valuemin', '0');
        control.setAttribute('aria-valuemax', '100');
        control.setAttribute('aria-valuenow', '50'); // Initial value
        control.setAttribute('tabindex', '0');  // Make it focusable

        // Add keyboard controls
        control.addEventListener('keydown', (e) => {
            let newProgress;
            const currentValue = parseInt(control.getAttribute('aria-valuenow'));

            switch (e.key) {
                case 'ArrowUp':
                case 'ArrowRight':
                    newProgress = Math.min(currentValue + 5, 90); // Limit to 90% instead of 100%
                    e.preventDefault();
                    break;
                case 'ArrowDown':
                case 'ArrowLeft':
                    newProgress = Math.max(currentValue - 5, 20); // Limit to 20% instead of 0%
                    e.preventDefault();
                    break;
                case 'Home':
                    newProgress = 20; // Match lower bound
                    e.preventDefault();
                    break;
                case 'End':
                    newProgress = 90; // Match upper bound
                    e.preventDefault();
                    break;
                default:
                    return;
            }

            // Convert percentage to progress (0-1)
            const progress = newProgress / 100;

            // Use the same bounds as the Draggable
            const boundedY = Math.max(
                (minY + (trackBounds.height * 0.2)) - startY,
                Math.min(
                    (maxY - (trackBounds.height * 0.1)) - startY,
                    ((1 - progress) * (maxY - minY)) + (minY - startY)
                )
            );

            gsap.to(handle, {
                y: boundedY,
                duration: 0.3,
                ease: "power2.out",
                onUpdate: function () {
                    updateFlowerAndAudio(progress, true);
                }
            });

            // Update ARIA value
            control.setAttribute('aria-valuenow', newProgress);
        });

        // Add live region for screen readers
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('class', 'sr-only');  // Visually hidden
        control.appendChild(liveRegion);

        // Update the updateFlowerAndAudio function to include accessibility updates
        const originalUpdateFunction = updateFlowerAndAudio;
        updateFlowerAndAudio = function (progress, shouldAnimateMorph = false) {
            originalUpdateFunction(progress, shouldAnimateMorph);

            // Update ARIA values
            const percentage = Math.round(progress * 100);
            control.setAttribute('aria-valuenow', percentage);

            // Update live region with meaningful description
            liveRegion.textContent = `Slider at ${percentage}%. ${progress >= 0.5 ? 'Animation speed increasing' : 'Animation speed decreasing'
                }`;
        }
    });

    // Assuming you have a Draggable or slider setup
    const flowerUp = document.querySelector('.flower__up');

    // In your drag or slider update function
    function updateFlower(progress) {
        // progress should be 0-1 where 0.5 is the middle position
        // Calculate scale: 1 at middle/top (0.5-0), 0.5 at bottom (1)
        const scale = progress > 0.5
            ? 1 - ((progress - 0.5) / 0.5) * 0.5  // Scale from 1 to 0.5 in bottom half
            : 1;  // Stay at 1 in top half

        gsap.to(flowerUp, {
            scaleX: scale,
            duration: 0.2,
            ease: "power2.out"
        });
    }

    // Add new audio setup near the other audio setup
    const secondSoundURL = require("url:../../audio/P_4_01.m4a");

    // Create second player with its own volume control
    const secondPlayer = new Tone.Player({
        url: secondSoundURL,
        loop: true,
        volume: -6,
    }).connect(secondPlayerGainNode);
}, false);